import styled from 'styled-components';
import { MainMenu, MainMenuItem } from '@make-software/cspr-design';
import { STAMPS_PATH, HOME_PATH, INBOX_PATH, OUTBOX_PATH } from '@/paths';

import { Link } from '../link';
import { useContext } from 'react';
import { ConnectedAccountContext } from '@/contexts';
import { useGetMessagesReceivedByAccount, useGetMessagesSentByAccount } from '@/hooks';

const MainMenuWrapper = styled.div(({ theme }) =>
  theme.withMedia({
    position: 'relative',
    padding: 0,
    paddingBottom: [19, 19, 0],
    width: ['100%', '100%', 'auto'],
    '& li': {
      ':last-child': {
        paddingRight: 0,
      },
    },
  })
);

const CounterBadge = styled.span<{ $warning: boolean }>(({ theme, $warning }) =>
  theme.withMedia({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '16px',
    height: '16px',
    padding: '0 5px',
    marginLeft: '6px',
    borderRadius: '999px',
    // backgroundColor: $active ? '#2F3EA8' : '#5C6175',
    backgroundColor: $warning ? '#B2332D' : '#2F3EA8',
    color: '#F2F2F2',
    fontSize: '10px',
    lineHeight: '14px',
    fontWeight: 600,
    position: 'relative',
    top: '-6px'
  })
);

const MenuItems = () => {
  const { connectedAccount, stampBalance } = useContext(ConnectedAccountContext);
  const { response: outbox } = useGetMessagesSentByAccount(connectedAccount?.public_key, 1, 1);
  const { response: inbox } = useGetMessagesReceivedByAccount(connectedAccount?.public_key, 1, 1);

  if (!connectedAccount) {
    return <></>;
  }

  return (
    <MainMenuWrapper>
      <MainMenu>
        <MainMenuItem>
          <Link to={HOME_PATH}>Home</Link>
        </MainMenuItem>
        <MainMenuItem>
          <Link to={STAMPS_PATH}>
            Stamps
            {stampBalance !== null && stampBalance !== undefined && (
              <CounterBadge $warning={!stampBalance}>{stampBalance}</CounterBadge>
            )}
          </Link>
        </MainMenuItem>
        <MainMenuItem>
          <Link to={OUTBOX_PATH}>Outbox</Link>
          {outbox?.itemCount !== null && outbox?.itemCount !== undefined && (
            <CounterBadge $warning={false}>{outbox?.itemCount}</CounterBadge>
          )}
        </MainMenuItem>
        <MainMenuItem>
          <Link to={INBOX_PATH}>Inbox</Link>
          {inbox?.itemCount !== null && inbox?.itemCount !== undefined && (
            <CounterBadge $warning={false}>{inbox?.itemCount}</CounterBadge>
          )}
        </MainMenuItem>
      </MainMenu>
    </MainMenuWrapper>
  );
};

export default MenuItems;
